theme.headerSearch = (function () {
  function searchOverlay(e) {
    const input = e.querySelector('input[type="search"]');

    const headerHeight = document.querySelector('.header__area');
    document.documentElement.style.setProperty('--header-height', `${headerHeight.clientHeight}px`);
    
    let quickDrawer = (trigger, closeTrigger, wrapper ) => {
      	let offcanvasSearchTrigger = document.querySelectorAll(trigger),
            offcanvasSidebarSearch = document.querySelector(wrapper),
      	    offcanvasSearchClose = document.getElementById(closeTrigger);
      
      	
        offcanvasSearchTrigger.forEach((singleTrigger) => {
			if (singleTrigger) {
              singleTrigger.addEventListener("click", (event) => {
                event.preventDefault();
                offcanvasSidebarSearch.classList.add("active");
                /* 7 Oct 2026: put the cursor in the search box on the first tap. It used to be focused only after the
                   slide-in animation ended, which phones (iOS) ignore, so a second tap was needed to type. */
                if (wrapper === "#predictive__search_overlay") {
                  if (!document.getElementById("chx-search-vis")) {
                    const st = document.createElement("style");
                    st.id = "chx-search-vis";
                    st.textContent = "html body #predictive__search_overlay{transition:opacity .3s,transform .3s,visibility 0s .3s}html body div#predictive__search_overlay.active{transition-delay:0s}";
                    document.head.appendChild(st);
                  }
                  const si = offcanvasSidebarSearch.querySelector('input[type="search"]');
                  if (si) { try { si.focus({ preventScroll: true }); } catch (_) { si.focus(); } }
                }

                offcanvasSidebarSearch.addEventListener(
                  "transitionend",
                  () => {
                    trapFocus(offcanvasSidebarSearch);
                     trapFocus(input);
                  },
                  { once: true }
                );
              });
              
              offcanvasSidebarSearch.addEventListener("keyup", (evt) => {
                if (evt.code === "Escape") {
                  offcanvasSidebarSearch.classList.remove("active");
                  removeTrapFocus(singleTrigger);
                }
              });
          
          		if (offcanvasSearchClose) {
                  offcanvasSearchClose.addEventListener("click", (event) => {
                    event.preventDefault();
                    offcanvasSidebarSearch.classList.remove("active");

                    removeTrapFocus(singleTrigger);
                  });
                }
            }
        })

        if(offcanvasSidebarSearch){
          document.addEventListener("click", function (event) {
            let eventTarget = event.target;
            if (
              !eventTarget.closest('#predictive__search_overlay, #quick__information_overlay') &&
              !eventTarget.closest('.header__actions_btn--search, .information--drawer__trigger')
            ) {
              offcanvasSidebarSearch.classList.remove("active");
            }
          });
        }

      
    }
    quickDrawer(".header__actions_btn--search", "search__close_btn", "#predictive__search_overlay");
  
    quickDrawer(".information--drawer__trigger", "quick__information--close_btn", "#quick__information_overlay");
    

  }
  return searchOverlay;
})();